import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './order.css';
import { Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import Transactions from './Ledger/Transactions';
import OrderSummary from './Ledger/OrderSummary';
import Settlements from './Ledger/Settlements';
import MonthlyReport from './Ledger/MonthlyReport';
import QuarterlyReport from './Ledger/QuarterlyReport';
import SellerReturns from './Ledger/SellerReturns';


function Payment() {

  const { path, url } = useRouteMatch()
  const currentUrl = window.location.pathname;
  useEffect(() => {
    let filterData = {
      "pageNo": "1"
    }

  }, [])
  return (
    <>

      <div className="container mb-4 overflow-scroll">
        {currentUrl=='/payment/my-transactions' || currentUrl=='/payment/order-summary' || currentUrl=='/payment/monthly_report' || currentUrl=='/payment/quarterly_report' || currentUrl === '/payment/seller-returns' ?
         <div className='filter_options order_nav_cntn d-flex tab w-sm-500'>
          <div className='container'>
            {currentUrl!=='/payment/settlements/completed' && <div className='ord_table' style={{ width: "100%" }}>
              <NavLink exact to={`${url}/my-transactions`} className="order_nav"><button className='filter_options_btn me-2' >Transactions <OverlayTrigger
                key="tds"
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-tds`} className="fs-16 order_page_tooltip">
                    <p className='fs-10 f-500 payment_page_tooltip_1'> Report is generated after the product is shipped.
                    </p>
                  </Tooltip>
                }
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </OverlayTrigger> </button></NavLink>
              <NavLink exact to={`${url}/order-summary`} className="order_nav"><button className='filter_options_btn me-2' >Order-Summary</button></NavLink>
               {/* <NavLink to={`${url}/settlements`} className="order_nav"><button className='filter_options_btn me-2'>Settlements</button></NavLink>  */}
              <NavLink to={`${url}/monthly_report`} className="order_nav"><button className='filter_options_btn me-2'>Monthly Report</button></NavLink>
              {/* Quarterly Report Ticket: SL-664 */}

              <NavLink to={`${url}/quarterly_report`} className="order_nav"><button className='filter_options_btn me-2'>Quarterly Report</button></NavLink>
              <NavLink to={`${url}/seller-returns`} className="order_nav"><button className='filter_options_btn me-2'>Seller Returns</button></NavLink>

            </div>}
          </div>
        </div> :""}
      </div>
      <div>
        <Route exact path="/payment">
          <Redirect to={`${path}/my-transactions`} />
        </Route>
        <Route exaxt path={`${path}/my-transactions`} component={Transactions} />
        <Route exact path={`${path}/order-summary`} component={OrderSummary} />
        <Route path={`${path}/settlements`} component={Settlements} />
        <Route path={`${path}/monthly_report`} component={MonthlyReport} />
        <Route path={`${path}/quarterly_report`} component={QuarterlyReport} />
        <Route path={`${path}/seller-returns`} component={SellerReturns} />

      </div>





    </>
  )




}


export default Payment;